import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { insertStringScript, removeErrorOnFocus } from "../../../common/util";
import { Field } from 'redux-form';
import FormSelect from "../../FormComponents/formSelect";
import FormSelectSearch from '../../FormComponents/formSelectSearch';
import InlineEditableField from '../../InlineEditableField';

const SingleChoiceList = (props) => {
    const [selectedItem, setSelectedItem] = useState("");
    const [selectItemTitle, setSelectItemTitle] = useState("");

    const onSelect = (data) => {
        setSelectedItem(data.option.Item1);
        setSelectItemTitle(data.option.Item2);
    };

    const clearErrorOnFocus = (e) => {
        if (!$('#' + e.target.name + 'errorBlock').is(':empty')) {
            $('#' + e.target.name + 'errorBlock').text('')
        }
    };

    const runPreScript = (id, preScript) => {
        insertStringScript(id, preScript)
    };

    const runPostScript = (id, postScript) => {
        insertStringScript(id, postScript)
    };

    const renderOnCard = () => {
        let { data, showLabel = false } = props;
        if (Array.isArray(data))
            data = data[0];
        return (showLabel) ?
            <li data-test={data.Label}><label>{data.Label || data.FieldGroup} </label> : <span>{data.Value ? data.Value : '-'}</span></li>
            :
            <li data-test={data.Value}>{data.Value ? data.Value : '-'}</li>
    };

    const renderOnGrid = () => {
        return (
            <div></div>
        )
    };

    const renderOnDetail = () => {
        let { renderType, data, showLabel = false } = props;
        if (Array.isArray(data))
            data = data[0];
        if (renderType.toLowerCase() === 'activity') {
            if (showLabel) {
                return (<li data-test={data.Label}><label>{data.Label}</label>
                    { <InlineEditableField
                        type={!data.Name.includes("dailyrepresentationcompany_singlechoicelist") ? "singlechoicelist" : "searchDropdown"}
                        data={data}
                        fieldValue={data.Value ? data.Value : '-'}
                        canEdit={props.canEditActivity}
                        isCompositeField={false}
                        removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                        updateField={(data) => props.updateActivityField(data)} />}

                </li>)
            } else {
                return (<li data-test={data.Value}>{data.Value ? data.Value : '-'}</li>)
            }
        } else if (renderType.toLowerCase() === 'workkard') {
            if (showLabel) {
                return (<li data-test={data.Label}>
                    <label data-field-label={props.isShowDetailOnPopUp ? data.FieldKey+"label_block" : data.FieldKey}>{data.Label} </label>
                    {(props.dragndrop || !props.isShowDetailOnPopUp)
                        ?(<span data-field-value={data.FieldKey}>{data.Value ? data.Value : data.Name.includes("Carrier") ? props.workkardDetail.CarrierNameAbbr || props.workkardDetail.CarrierName : "-"}</span>)
                        : data.Name.includes("Carrier") ?
                        <InlineEditableField
                            type="searchDropdown"
                            data={{FieldKey:"hdnshowcarriername", Name:"hdnshowcarriername", Options:props.workkardDetail.workkardCarriers,IsNonEditable:false, dataValue:props.workkardDetail.CarrierName,IsRequired:true}}
                            fieldValue={props.workkardDetail.CarrierNameAbbr ? props.workkardDetail.CarrierNameAbbr :props.workkardDetail.CarrierName}
                            canEdit={props.canEditWorkkard}
                            removeErrorOnFocus={(e) =>removeErrorOnFocus(e)}
                            updateField={(data) => props.updateWorkkardFieldInfo(data)} /> : <InlineEditableField
                            type={!data.Name.includes("dailyrepresentationcompany_singlechoicelist") ? "singlechoicelist" : "searchDropdown"}
                            data={data}
                            canEdit={props.canEditWorkkard}
                            isCompositeField={false}
                            fieldValue={data.Value ? data.Value : '-'}
                            removeErrorOnFocus={(e) => removeErrorOnFocus(e)}
                            updateField={(data) => props.updateWorkkardFieldInfo(data)} 
                        />
                    }
                </li>);
            } else {
                return (data?.Value ??  '-');
            }
        } else {
            return (showLabel) ?
                (<React.Fragment><label>{data.Label}: </label>{data?.Value ?? '-'}</React.Fragment>)
                :
                (data?.Value ?? '-')
        }
    };

    const getDefaultCustomFieldValue = () => {
        if (props.data?.fieldType?.includes('timezone')) {
            if (props.data.value && (selectedItem != props.data.value)) {
                setSelectedItem(props.data.value);
                props.onFieldValueChange({ name: props.data.fieldType, value: props.data.value });
                return
            }
        } else {
            if (selectedItem != "") {
                return selectedItem
            }
            if (props.data.CustomFieldValues.length == 1 && props.data.CustomFieldValues[0].Value != "-1") {
                props.onFieldValueChange({ name: props.data.FieldKey, value: props.data.CustomFieldValues[0].Value })
                return setSelectedItem(props.data.CustomFieldValues[0].Value);
            } else {
                if (props.data.CustomFieldValues[0].Value != "-1") {
                    props.setDefaultValue({ name: props.data.FieldKey, value: props.data.CustomFieldValues[0].Value })
                }
                return setSelectedItem(props.data.Value == null ? "-1" : props.data.Value);
            }
        }
    };

    const renderOnCreate = () => {
        let { renderType, data, showLabel = false } = props;
        if (Array.isArray(data))
            data = data[0];
        if (renderType.toLowerCase() === "activity") {
            if (data.Name.includes("dailyrepresentationcompany_singlechoicelist")) {
                return (<div className="formGroup">
                    {data.Label.trim() != "" && <div className="wth-3"><label>{data.Label}{data.IsRequired && <sup>*</sup>}</label></div>}
                    <div className="wth-4">
                        <Field
                            component={FormSelectSearch}
                            Id={data.Name}
                            iconName="chev"
                            openOnHover={false}
                            openOnClick={true}
                            styleClass="icon"
                            widthClass=""
                            selected={selectedItem ? selectedItem : data.Value ? data.Value : -1}
                            onSelect={(data) => { onSelect(data); props.onSelectValueChange(data); }}
                            title={selectItemTitle === "" ? data.Options[0].Item1 : selectItemTitle}
                            name={data.Name}
                            options={data.Options}
                            data={data.Value}
                            isDisabled={props.isEdit && data.IsNonEditable}
                            wrapperClass=""
                            className=""
                        />
                    </div>
                </div>
                )
            }
            else {
                return (
                    <Field
                        component={FormSelect}
                        wrapperClass=""
                        className=""
                        divClass={data.FieldType != "timezone" ? "wth-4" : ""}
                        labeldivclass="wth-3"
                        name={data.Name}
                        type={data.FieldType}
                        isRequired={data.IsRequired}
                        label={data.Label}
                        options={data.Options}
                        data={data.Value}
                        valueKey={data.FieldType == "timezone" ? "UniversalTimeZoneId" : null}
                        labelKey={data.FieldType == "timezone" ? "DisplayText" : null}
                        selected={data.Value}
                        isDisabled={props.isEdit && data.IsNonEditable}
                    />
                )

            }
        }
        else {
            const fieldSetting = data.settings ? JSON.parse(data.settings) : {};
            let optionItems = data?.CustomFieldValues?.map((element) =>
                <option key={element.Id} value={element.Value || element.UniversalTimeZoneId} selected={((data.Value == element.Value) || (data.Value == element.UniversalTimeZoneId)) ? true : false}>{element.DisplayName || element.DisplayText}</option>
            );
            if (renderType.toLowerCase() === 'note') {
                return (showLabel) ?
                    (<div data-field-key={data.FieldKey}>
                        <label required-field-Key={data.FieldKey}>{data.Label}{data.IsMandatory ? <span className="red">*</span> : ""} </label>
                        <div className={`FieldBlock SingleChoiceList ${data.Label == "" ? 'timesIndia' : ''}`}>
                            <select type="text" id={data.FieldKey} name={data.FieldKey} placeholder="ssssss" disabled={fieldSetting?.timezone_iseditable === undefined ? false : !fieldSetting.timezone_iseditable} value={getDefaultCustomFieldValue()} onFocus={(e) => clearErrorOnFocus(e)} onChange={(e) => { setSelectedItem(e.target.value); props.onFieldValueChange(e.target) }} >
                                {optionItems}
                            </select>
                            <span id={data.FieldKey + "errorBlock"} className="errorSelfMsg"></span>
                        </div>
                    </div>)
                    :
                    (<div>{data.Value}</div>)
            }
        }
    };

    useEffect(() => {
        const data = Array.isArray(props.data) ? props.data[0] : props.data;
        if (data && data.preInitScript) {
            runPreScript(`preInitScript-${data.FieldKey}`, data.preInitScript);
        }
        // if (preSaveScript) {
        //     runPostScript(`preSaveScript-${data.FieldKey}`,preSaveScript);
        // }
    }, []);

    const isFirstRender = useRef(true);
    const prevDataRef = useRef(props.data);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            prevDataRef.current = props.data;
            return;
        }
        const oldData = Array.isArray(prevDataRef.current) ? prevDataRef.current[0] : prevDataRef.current;
        const newData = Array.isArray(props.data) ? props.data[0] : props.data;
        if (oldData && oldData.Id != newData.Id && props.renderType.toLowerCase() === 'note') {
            const oldPreInitScripts = document.querySelector(`script[id='preInitScript-${oldData.FieldKey}']`);
            const oldPreSaveScripts = document.querySelector(`script[id='preSaveScript-${oldData.FieldKey}']`);
            const newPreInitScript = newData.preInitScript;
            const newPreSaveScript = newData.PreSaveScript;
            if (oldPreInitScripts) {
                oldPreInitScripts.parentNode.removeChild(oldPreInitScripts);
            }
            if (oldPreSaveScripts) {
                oldPreSaveScripts.parentNode.removeChild(oldPreSaveScripts);
            }
            if (newPreInitScript) {
                runPreScript(`preInitScript-${newData.FieldKey}`, newPreInitScript);
            }
            if (newPreSaveScript) {
                runPostScript(`preSaveScript-${newData.FieldKey}`, newPreSaveScript);
            }
        }
        prevDataRef.current = props.data;
    }, [props.data]);

    switch (props.renderLocation.toLowerCase()) {
        case "card":
            return renderOnCard();
        case "grid":
            return renderOnGrid();
        case "detail":
            return renderOnDetail();
        case "create":
            return renderOnCreate();
    }
};

export default SingleChoiceList;
